import React, { useEffect, useState } from "react";
import "./StudyMaterialPage.scss";
import WebService from "../../../Services/WebService";
import { GoDownload } from "react-icons/go";
import { FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import DefaultImage from "../../../assets/images/fromtheground.png";

interface StudyMaterial {
  id: number;
  uuid: string;
  title: string;
  description: string;
  author: string;
  file: string | null;
  thumb_image: string | null;
  status: string;
  cover_resource: string | null;
  is_locked: boolean; // backend flag
}

const StudyMaterialPage: React.FC = () => {
  const [materials, setMaterials] = useState<StudyMaterial[]>([]);
  const [search, setSearch] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [expandedIds, setExpandedIds] = useState<number[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMaterials();
  }, []);

  const fetchMaterials = async () => {
    try {
      setShowLoader(true);
      setDataLoaded(false);
      const res: any = await WebService.getAPI({ action: "/study/list" });
      if (res && res.list) {
        setMaterials(res.list);
      } else {
        setMaterials([]);
      }
    } catch (error) {
      console.error("Error fetching study materials:", error);
      setMaterials([]);
    } finally {
      setShowLoader(false);
      setDataLoaded(true);
    }
  };

  const toggleExpand = (id: number) => {
    setExpandedIds((prev) => (prev.includes(id) ? [] : [id])); // only one expanded
  };

  const filteredMaterials = materials.filter((item) =>
    (item.title || "").toLowerCase().includes(search.toLowerCase())
  );

  // Navigate to details page where you will handle buy/unlock/download logic
  const handleCardClick = (uuid: string) => {
    navigate(`/studyDetails/${uuid}`);
  };

  return (
    <div className="study-material-container">
      <div className="header-section">
        <h5>Study Material</h5>
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {showLoader && (
        <div className="loader-wrapper">
          <Loader show={true} />
        </div>
      )}

      {!showLoader && dataLoaded && (
        <>
          {filteredMaterials.length === 0 ? (
            <p className="no-data text-center">No study materials found.</p>
          ) : (
            <div className="material-grid">
              {filteredMaterials.map((item) => (
                <div
                  key={item.id}
                  className="material-card"
                   onClick={() => handleCardClick(item.uuid)}
                >
                  <div
                    className="thumb-wrapper"
                   
                    role="button"
                    tabIndex={0}
                    onKeyDown={() => {}}
                  >
                    <img
                      src={item.thumb_image ? item.thumb_image : DefaultImage}
                      alt={item.title}
                      className="material-thumb"
                    />

                    {/* LOCK BADGE (top-left) */}
                    {/* {item.is_locked && (
                      <div className="lock-badge" title="Locked — purchase to unlock">
                        <FaLock />
                      </div>
                    )} */}
                  </div>

                  <div className="material-details cursor-pointer">
                    <h6 className="material-title">{item.title}</h6>
                    <p className="material-author">By {item.author}</p>

                    <div className="material-description cursor-pointer">
                      <p
                        className={`desc-text desc-${item.id} ${
                          expandedIds.includes(item.id) ? "expanded" : ""
                        }`}
                        dangerouslySetInnerHTML={{ __html: item.description || "" }}
                      ></p>

                      {/* {item.description && item.description.length > 120 && (
                        <span
                          className="read-toggle"
                          onClick={() => toggleExpand(item.id)}
                        >
                          {expandedIds.includes(item.id) ? "Read less" : "Read more"}
                        </span>
                      )} */}
                    </div>

                    <div className="download-row">
                      <button
                        className="download-link"
                        onClick={() => handleCardClick(item.uuid)}
                      >
                        <span>Download</span>
                        <GoDownload />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default StudyMaterialPage;
